import axios from 'axios';

const axiosBase = axios.create({
	// baseURL: 'https://api-portal-dev-dreamfill.azurewebsites.net'
	baseURL: 'https://api-portal.dreamfillservices.com'
});

axiosBase.interceptors.request.use(config => {
	$('.preloader').show();
	return config
});

axiosBase.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    $('.preloader').hide();
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    $('.preloader').hide();
    return Promise.reject(error);
  });

export default axiosBase;